<template>
  <div>
    <br /><br />
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="mappingTable" v-else>
    <div v-if="courseOutcomes.length>0">
      <div class="" style="border: 2px solid #17a2b8; padding: 15px; border-radius: 5px;">
        <ul>
          <!-- You have two options to copy course data: -->
          <!-- <li>
            Copy from University Resources <span style="color: #2929aa; text-decoration: underline; cursor: pointer;"
              @click="copy_from = 'template'; $bvModal.show('copyCoursePropertiesModel')">Click here to proceed</span>
          </li> -->
          <li>Copy from previous academic year <span
              style="color: #2929aa; text-decoration: underline; cursor: pointer;"
              @click="copy_from = 'myinstitute'; $bvModal.show('copyCoursePropertiesModel')">Click here to
              proceed</span>
          </li>
        </ul>
        <b-modal id="copyCoursePropertiesModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
          hide-header centered size="md">
          <CopyCourseProperties :copy_from_suggestion="copy_from" :course_id="courseId"
            @success="propertyCopyCompleted()" @cancel="$bvModal.hide('copyCoursePropertiesModel')" />
        </b-modal>
      </div>
      <div class="text-center m-2 text-primary"> OR </div>

      <div v-if=" editCourseComponents && $store.getters.defaultInstitute.userRole != 'Student'">
        <b-button class="mb-2" v-if="!editTable" size="sm" variant="primary" @click="editTable = true">Edit</b-button>
        <div v-else class="d-flex justify-content-between mb-2">
          <b-button variant="primary" @click="saveMappings()" size="sm" :disabled="saveChanges.disabled">{{
            saveChanges.text
            }}</b-button>
          <b-button size="sm" @click="cancel()" variant="danger">Cancel</b-button>
        </div>
      </div>
      <div class="mb-2" v-else>This data can only be edited by course instructor</div>

      <div class="mb-2" v-if="canEditMappings">
        <b-form-checkbox v-model="mappingHeaders.wk" inline @change="saveMappingHeaders()">Show WK column</b-form-checkbox>
        <b-form-checkbox v-model="mappingHeaders.sdg" inline @change="saveMappingHeaders()">Show SDG column</b-form-checkbox>
      </div>

      <div class="d-flex">
        <div class="table-responsive" style="height: auto !important;">
          <table class="table table-bordered table-striped">
            <thead class="thead-dark text-left">
              <tr class="text-center">
                <th></th>
                <th style="min-width: 90px;" v-for="(pso, psoIndex) in enabledProgramSpecificOutcomes"
                  :key="psoIndex + 'psoHeader'">
                  {{ pso.code }}
                </th>
                <th style="min-width: 90px;" v-for="(po, poIndex) in enabledProgramOutcomes"
                  :key="poIndex + 'poHeader'">
                  {{ po.code }}
                </th>
                <th style="min-width: 90px;" v-if="mappingHeaders.wk">WK</th>
                <th style="min-width: 90px;" v-if="mappingHeaders.sdg">SDG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(co, coIndex) in courseOutcomes" :key="coIndex + 'coIndex'">
                <td>{{ co.code }}</td>

                <td v-for="(pso, psoIndex) in enabledProgramSpecificOutcomes" :key="psoIndex + 'psoIndex'"
                  class="text-center align-middle">
                  <span v-if="!editTable" class="text-center">
                    <span v-if="coPsoMappingData[co.id][pso.id].level == 0 ||
                      coPsoMappingData[co.id][pso.id].level == 0.0
                      || coPsoMappingData[co.id][pso.id].level == 'NaN'">-</span>
                    <span v-else>
                      {{
                      coPsoMappingData[co.id][pso.id].level
                      }}
                    </span>
                  </span>
                  <div v-else>
                    <b-form-input v-model="coPsoMappingData[co.id][pso.id].level" style="text-align: center"
                      type="number" :max="highestMappingLevel" step=".1"></b-form-input>
                  </div>
                </td>

                <td v-for="(po, poIndex) in enabledProgramOutcomes" :key="poIndex + 'poIndex'"
                  class="text-center align-middle">
                  <span v-if="!editTable" class="text-center">
                    <span v-if="coPoMappingData[co.id][po.id].level == 0 ||
                      coPoMappingData[co.id][po.id].level == 0.0
                      || coPoMappingData[co.id][po.id].level == 'NaN'">-</span>
                    <span v-else>
                      {{
                      coPoMappingData[co.id][po.id].level
                      }}
                    </span>
                  </span>
                  <div v-else>
                    <b-form-input v-model="coPoMappingData[co.id][po.id].level" style="text-align: center" type="number"
                      :max="highestMappingLevel" step=".1"></b-form-input>
                  </div>
                </td>

                <td class="text-center align-middle" v-if="mappingHeaders.wk">
                  <span v-if="!coWkMappingData[co.id] || coWkMappingData[co.id].length === 0">
                    <span v-if="canEditMappings && editTable" class="text-info btn p-0 m-0" @click="openWkModal(co.id)">Add</span>
                    <span v-else>-</span>
                  </span>
                  <span v-else-if="canEditMappings && editTable" class="text-info btn p-0 m-0" @click="openWkModal(co.id)">
                    {{ wkCodesFor(co.id) }}
                  </span>
                  <span v-else>
                    {{ wkCodesFor(co.id) }}
                  </span>
                </td>

                <td class="text-center align-middle" v-if="mappingHeaders.sdg">
                  <span v-if="!coSdgMappingData[co.id] || coSdgMappingData[co.id].length === 0">
                    <span v-if="canEditMappings && editTable" class="text-info btn p-0 m-0" @click="openSdgModal(co.id)">Add</span>
                    <span v-else>-</span>
                  </span>
                  <span v-else-if="canEditMappings && editTable" class="text-info btn p-0 m-0" @click="openSdgModal(co.id)">
                    {{ sdgNamesFor(co.id) }}
                  </span>
                  <span v-else>
                    {{ sdgNamesFor(co.id) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>Avg</td>
                <td v-for="(pso, psoIndex) in enabledProgramSpecificOutcomes" :key="psoIndex + 'psoIndex'"
                  class="text-center align-middle">
                  {{ coPsoMappingDataAvg[pso.id]['avg'] ? coPsoMappingDataAvg[pso.id]['avg'].toFixed(1) : '-' }}
                </td>
                <td v-for="(po, poIndex) in enabledProgramOutcomes" :key="poIndex + 'poIndex'"
                  class="text-center align-middle">
                  {{ coPoMappingDataAvg[po.id]['avg'] ? coPoMappingDataAvg[po.id]['avg'].toFixed(1) : '-' }}
                </td>
                <td v-if="mappingHeaders.wk"></td>
                <td v-if="mappingHeaders.sdg"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-responsive" style="height: auto !important;">
        <table class="table table-bordered table-striped">
          <thead class="thead-dark text-left">
            <tr class="text-center">
              <th>COs</th>
              <th>PSOs</th>
              <th>POs</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in maximumCoPoPsoTableRows" :key="index">
              <td>
                <span v-if="courseOutcomes[index-1]">
                  {{ courseOutcomes[index-1].code }}-{{ courseOutcomes[index-1].outcome }}
                </span>
              </td>
              <td>
                <span v-if="programSpecificOutcomes[index-1]">
                  <b-form-checkbox :disabled="!editTable" v-model="enabledPsoIds" name="checkbox-psoOption"
                    :value="programSpecificOutcomes[index-1].id">
                    {{ programSpecificOutcomes[index-1].code }}-{{ programSpecificOutcomes[index-1].outcome }}
                  </b-form-checkbox>
                </span>
              </td>
              <td>
                <span v-if="programOutcomes[index-1]">
                  <b-form-checkbox :disabled="!editTable" v-model="enabledPoIds" name="checkbox-psoOption"
                    :value="programOutcomes[index-1].id">
                    {{ programOutcomes[index-1].code }}-{{ programOutcomes[index-1].outcome }}
                  </b-form-checkbox>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-modal id="wkMappingModal" title="Select Washington Accord Knowledge Profiles (WK)" hide-header-close
        no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer centered size="md">
        <span class="text-danger" v-if="wks.length < 1">WK list is empty for this programme</span>
        <b-form-checkbox v-for="wk in wks" :key="wk.id" v-model="wkModalSelectedIds" :value="wk.id">
          {{ wk.code }}-{{ wk.outcome }}
        </b-form-checkbox>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="primary" size="sm" class="mr-2" @click="saveWkMapping()"
            :disabled="wkModalSaving">Update</b-button>
          <b-button variant="danger" size="sm" @click="$bvModal.hide('wkMappingModal')">Cancel</b-button>
        </div>
      </b-modal>

      <b-modal id="sdgMappingModal" title="Select Sustainable Development Goal (SDG)" hide-header-close
        no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer centered size="md">
        <b-form-checkbox v-for="sdg in sdgOptions" :key="sdg.value" v-model="sdgModalSelectedIds" :value="sdg.value">
          {{ sdg.value }}. {{ sdg.text }}
        </b-form-checkbox>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="primary" size="sm" class="mr-2" @click="saveSdgMapping()"
            :disabled="sdgModalSaving">Update</b-button>
          <b-button variant="danger" size="sm" @click="$bvModal.hide('sdgMappingModal')">Cancel</b-button>
        </div>
      </b-modal>

      <!-- <h5>COs</h5>
      <span class="text-danger" v-if="(courseOutcomes.length<1)">List is empty</span>
      <ul>
        <li v-for="co in courseOutcomes" :key="co.id">{{ co.code }}-{{ co.outcome }}
        </li>
      </ul>

      <h5>PSOs</h5>
      <span class="text-danger" v-if="(programSpecificOutcomes.length<1)">List is empty</span>
      <ul>
        <span v-for="pso in programSpecificOutcomes" :key="pso.id">
          <li v-if="editTable">
            <b-form-checkbox v-model="enabledPsoIds" name="checkbox-psoOption" :value="pso.id">
              {{ pso.code }}-{{ pso.outcome }}
            </b-form-checkbox>
          </li>
          <li v-if="!editTable && enabledPsoIds.includes(pso.id)"> {{ pso.code }}-{{ pso.outcome }}</li>
        </span>
      </ul>

      <h5>POs</h5>
      <span class="text-danger" v-if="(programOutcomes.length<1)">List is empty</span>
      <ul>
        <span v-for="po in programOutcomes" :key="po.id">
          <li v-if="editTable">
            <b-form-checkbox v-model="enabledPoIds" name="checkbox-poOption" :value="po.id">
              {{ po.code }}-{{ po.outcome }}
            </b-form-checkbox>
          </li>
          <li v-if="(enabledPoIds.includes(po.id) && !editTable)">
            {{ po.code }}-{{ po.outcome }}
          </li>
        </span>
      </ul> -->
    </div>
    <div v-else>
      <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
    </div>
    </div>

  </div>
</template>

<script>
// import CoPoMapping from "./CoPoMapping.vue";

import CopyCourseProperties from "../CopyCourseProperties.vue"
import axios from "axios";
export default {
  props: ["courseId", "usergroupId", "editCourseComponents", "courseInfo"],
  async created() {
    this.loadCoPoPsoMapping();
    // this.fetchData = true;
  },
  components: {
    CopyCourseProperties
  },
  data() {
    return {
      errorMessage: "Course outcomes are not available in the source course.", // Your error message
      fetchData: false,
      coPoMappingData: {},
      coPoMappingDataAvg: {},
      coPsoMappingData: {},
      coPsoMappingDataAvg:{},
      courseOutcomes: [],
      programOutcomes: [],
      programSpecificOutcomes: [],
      enabledPoIds: [],
      enabledPsoIds: [],
      saveChanges: {
        text: "Save Changes",
        disabled: false,
      },
      highestMappingLevel: null,
      copy_from: '',
      editTable: false,

      wks: [],
      coWkMappingData: {},
      wkModalSelectedIds: [],
      wkModalSaving: false,

      sdgOptions: [
        { value: 1, text: 'No Poverty' },
        { value: 2, text: 'Zero Hunger' },
        { value: 3, text: 'Good Health and Well-being' },
        { value: 4, text: 'Quality Education' },
        { value: 5, text: 'Gender Equality' },
        { value: 6, text: 'Clean Water and Sanitation' },
        { value: 7, text: 'Affordable and Clean Energy' },
        { value: 8, text: 'Decent Work and Economic Growth' },
        { value: 9, text: 'Industry, Innovation, and Infrastructure' },
        { value: 10, text: 'Reduced Inequalities' },
        { value: 11, text: 'Sustainable Cities and Communities' },
        { value: 12, text: 'Responsible Consumption and Production' },
        { value: 13, text: 'Climate Action' },
        { value: 14, text: 'Life Below Water' },
        { value: 15, text: 'Life on Land' },
        { value: 16, text: 'Peace, Justice, and Strong Institutions' },
        { value: 17, text: 'Partnerships for the Goals' },
      ],
      coSdgMappingData: {},
      sdgModalSelectedIds: [],
      sdgModalSaving: false,

      activeCoId: null,

      defaultMappingHeaders: {
        wk: false,
        sdg: false,
      },
      mappingHeaders: {
        wk: false,
        sdg: false,
      },
    };
  },
  computed: {
    canEditMappings() {
      return this.editCourseComponents && this.$store.getters.defaultInstitute.userRole != 'Student';
    },
    maximumCoPoPsoTableRows() {
      return Math.max(
        this.courseOutcomes.length,
        this.programOutcomes.length,
        this.programSpecificOutcomes.length,);
    },
    enabledProgramOutcomes() {
      return this.programOutcomes.filter(obj => this.enabledPoIds.includes(obj.id));
    },
    enabledProgramSpecificOutcomes() {
      return this.programSpecificOutcomes.filter(obj => this.enabledPsoIds.includes(obj.id));
    },
  },
  methods: {
    async loadCoPoPsoMapping() {
      this.editTable = false;
      this.fetchData = true;

      await Promise.all([
        this.getCourseOutcomes(),
        this.getProgramOutcomes(),
        this.getProgramSpecificOutcomes(),
        this.getMappingLevel(),
        this.getWks(),
        this.getMappingHeaders(),
      ]);

      await this.courseOutcomes.forEach((co) => {
        this.$set(this.coPoMappingData, co.id, {});
        this.$set(this.coPsoMappingData, co.id, {});
        this.$set(this.coWkMappingData, co.id, []);
        this.$set(this.coSdgMappingData, co.id, []);
        this.programOutcomes.forEach((po) => {
          this.$set(this.coPoMappingData[co.id], po.id, { level: Number(0) });
          this.$set(this.coPoMappingDataAvg, po.id, { sum: Number(0) ,count: Number(0) ,avg: Number(0) })
        })
        this.programSpecificOutcomes.forEach((pso) => {
          this.$set(this.coPsoMappingData[co.id], pso.id, { level: Number(0) });
          this.$set(this.coPsoMappingDataAvg, pso.id, { sum: Number(0) ,count: Number(0) ,avg: Number(0) })
        })
      });

      await Promise.all([
        this.getCoPoMapping(),
        this.getCoPsoMapping(),
        this.getCoWkMapping(),
        this.getCoSdgMapping(),
      ]);

      // enable all by default
      if (this.enabledPoIds.length < 1 ) {
        this.programOutcomes.forEach((po) => {
          this.enabledPoIds.push(po.id);
        });
      }

      if (this.enabledPsoIds.length < 1) {
        this.programSpecificOutcomes.forEach((pso) => {
          this.enabledPsoIds.push(pso.id);
        });
      }


      this.fetchData = false;
    },

    async getCourseOutcomes() {
      let courseOutcomeUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
      const url = courseOutcomeUrl.replace("course_id", this.courseId);
      await axios
        .get(url)
        .then((response) => {
          this.courseOutcomes = response.data;
        })
        .catch(() => {
          // console.log(error.response);
        });
    },
    async getProgramOutcomes() {
      const url = this.$store.getters.getAPIKey.programOutcome + `?
      usergroup=${this.usergroupId}&course=${this.courseId}`;
      await axios
        .get(url)
        .then((response) => {
          this.programOutcomes = response.data;
        })
        .catch(() => {
        });
    },
    async getProgramSpecificOutcomes() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/programmespecificoutcomes?usergroup=${this.usergroupId}&course=${this.courseId}`;
      await axios
        .get(url)
        .then((response) => {
          // console.log("getProgramSpecificOutcomes");
          this.programSpecificOutcomes = response.data;
        })
        .catch(() => {
        });
    },
    async getMappingLevel() {
      const settingKey = "co_po_mapping_level";
      let mainUrl = this.$store.getters.getAPIKey.institutionSettings;
      const url = mainUrl.replace("setting_key", settingKey);
      await axios
        .get(url)
        .then((response) => {
          this.highestMappingLevel = response.data;
        })
        .catch(() => {
          // console.log(error.response);
        });
    },

    async getMappingHeaders() {
      const groupId = this.courseInfo?.usersubgroup?.programme_config_group_id;
      if (!groupId) return;
      const url = this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${groupId}/co_po_pso_mapping`;
      await axios
        .get(url)
        .then((response) => {
          this.mappingHeaders = Object.assign({}, this.defaultMappingHeaders, response.data || {});
        })
        .catch(() => {
        });
    },
    async saveMappingHeaders() {
      const groupId = this.courseInfo?.usersubgroup?.programme_config_group_id;
      if (!groupId) return;
      const url = this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${groupId}/co_po_pso_mapping`;
      await axios
        .post(url, { co_po_pso_mapping: this.mappingHeaders })
        .catch(() => {
          this.$toast.error("Failed to update column visibility settings", {
            position: "top",
            duration: 5000,
          });
        });
    },

    async getCoPoMapping() {
      let mainUrl = this.$store.getters.getAPIKey.getcopoMapping;
      const url = mainUrl.replace("course_id", this.courseId);
      await axios
        .get(url)
        .then((response) => {
          let coPoMappingsResponse = response.data;
          coPoMappingsResponse.forEach(mapping => {
            if (!this.coPoMappingData[mapping.course_outcome_id]?.[mapping.programme_outcome_id]) return;
            this.coPoMappingData[mapping.course_outcome_id][mapping.programme_outcome_id].level = mapping.level;
            if (!this.enabledPoIds.includes(mapping.programme_outcome_id)) this.enabledPoIds.push(mapping.programme_outcome_id);
            if (mapping.level > 0) {
              this.coPoMappingDataAvg[mapping.programme_outcome_id]['sum'] += Number(mapping.level);
              this.coPoMappingDataAvg[mapping.programme_outcome_id]['count']++;
            }
          });
          this.programOutcomes.forEach((po) => {
            this.coPoMappingDataAvg[po.id]['avg']
              = Number(this.coPoMappingDataAvg[po.id]['sum']) /
              Number(this.coPoMappingDataAvg[po.id]['count'])
          })
        })
        .catch(() => {
          // console.log(error.response);
        });
    },
    // Get CoPso Mapping
    async getCoPsoMapping() {
      // this.fetchData = true;
      let mainUrl = this.$store.getters.getAPIKey.getcopsoMapping;
      const url = mainUrl.replace("course_id", this.courseId);
      await axios
        .get(url)
        .then((response) => {
          let coPsoMappingsResponse = response.data;
          coPsoMappingsResponse.forEach(mapping => {
            if (!this.coPsoMappingData[mapping.course_outcome_id]?.[mapping.programme_specificoutcome_id]) return;
            this.coPsoMappingData[mapping.course_outcome_id][mapping.programme_specificoutcome_id].level = mapping.level;
            if (!this.enabledPsoIds.includes(mapping.programme_specificoutcome_id)) this.enabledPsoIds.push(mapping.programme_specificoutcome_id);
            if (mapping.level > 0) {
              this.coPsoMappingDataAvg[mapping.programme_specificoutcome_id]['sum'] += Number(mapping.level);
              this.coPsoMappingDataAvg[mapping.programme_specificoutcome_id]['count']++;
            }
          });
          this.programSpecificOutcomes.forEach((pso) => {
            this.coPsoMappingDataAvg[pso.id]['avg']
              = Number(this.coPsoMappingDataAvg[pso.id]['sum']) /
              Number(this.coPsoMappingDataAvg[pso.id]['count'])
          })
        })
        .catch(() => {
          // console.log(error.response);
        });
    },

    async getWks() {
      const url = this.$store.getters.getAPIKey.wk + `?usergroup=${this.usergroupId}&course=${this.courseId}`;
      await axios
        .get(url)
        .then((response) => {
          this.wks = response.data;
        })
        .catch(() => {
        });
    },
    wkCodesFor(coId) {
      const ids = this.coWkMappingData[coId] || [];
      return this.wks.filter(wk => ids.includes(wk.id)).map(wk => wk.code).join(', ');
    },
    async getCoWkMapping() {
      let mainUrl = this.$store.getters.getAPIKey.getcowkMapping;
      const url = mainUrl.replace("course_id", this.courseId);
      await axios
        .get(url)
        .then((response) => {
          response.data.forEach(mapping => {
            if (!this.coWkMappingData[mapping.course_outcome_id]) {
              this.$set(this.coWkMappingData, mapping.course_outcome_id, []);
            }
            this.coWkMappingData[mapping.course_outcome_id].push(mapping.wk_id);
          });
        })
        .catch(() => {
        });
    },
    openWkModal(coId) {
      this.activeCoId = coId;
      this.wkModalSelectedIds = [...(this.coWkMappingData[coId] || [])];
      this.$bvModal.show('wkMappingModal');
    },
    async saveWkMapping() {
      this.wkModalSaving = true;
      const url = this.$store.getters.getAPIKey.cowkMapping;
      await axios
        .post(url, {
          course_outcome_id: this.activeCoId,
          wk_ids: this.wkModalSelectedIds,
        })
        .then(() => {
          this.$set(this.coWkMappingData, this.activeCoId, [...this.wkModalSelectedIds]);
          this.$bvModal.hide('wkMappingModal');
          this.$toast.success("WK mapping updated successfully", {
            position: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Failed to update WK mapping", {
            position: "top",
            duration: 5000,
          });
        });
      this.wkModalSaving = false;
    },

    sdgNamesFor(coId) {
      const ids = this.coSdgMappingData[coId] || [];
      return [...ids].sort((a, b) => a - b).map(id => `SDG ${id}`).join(', ');
    },
    async getCoSdgMapping() {
      let mainUrl = this.$store.getters.getAPIKey.getcosdgMapping;
      const url = mainUrl.replace("course_id", this.courseId);
      await axios
        .get(url)
        .then((response) => {
          response.data.forEach(mapping => {
            if (!this.coSdgMappingData[mapping.course_outcome_id]) {
              this.$set(this.coSdgMappingData, mapping.course_outcome_id, []);
            }
            this.coSdgMappingData[mapping.course_outcome_id].push(mapping.sdg);
          });
        })
        .catch(() => {
        });
    },
    openSdgModal(coId) {
      this.activeCoId = coId;
      this.sdgModalSelectedIds = [...(this.coSdgMappingData[coId] || [])];
      this.$bvModal.show('sdgMappingModal');
    },
    async saveSdgMapping() {
      this.sdgModalSaving = true;
      const url = this.$store.getters.getAPIKey.cosdgMapping;
      await axios
        .post(url, {
          course_outcome_id: this.activeCoId,
          sdgs: this.sdgModalSelectedIds,
        })
        .then(() => {
          this.$set(this.coSdgMappingData, this.activeCoId, [...this.sdgModalSelectedIds]);
          this.$bvModal.hide('sdgMappingModal');
          this.$toast.success("SDG mapping updated successfully", {
            position: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Failed to update SDG mapping", {
            position: "top",
            duration: 5000,
          });
        });
      this.sdgModalSaving = false;
    },

    propertyCopyCompleted() {
      this.$bvModal.hide('copyCoursePropertiesModel')
      // this.cancel();
      this.loadCoPoPsoMapping();
    },
    async cancel() {
      this.loadCoPoPsoMapping();
    },



    async saveMappings() {
      this.saveChanges.text = "Saving....";
      this.saveChanges.disabled = true;

      let course_outcome_ids = [];
      await this.courseOutcomes.forEach((co) => {
        course_outcome_ids.push(co.id);
      });

      let error = false;

      let coPoMappingPostData = [];
      await this.courseOutcomes.forEach((co) => {
        this.programOutcomes.forEach((po) => {
          if (this.enabledPoIds.includes(po.id)) coPoMappingPostData.push({
            course_outcome_id: co.id,
            programme_outcome_id: po.id,
            level: parseFloat(this.coPoMappingData[co.id][po.id].level).toFixed(1),
          });
        });
      });
      this.$store.getters.getAPIKey.copoMapping;
      let url = this.$store.getters.getAPIKey.copoMapping;
      await axios
        .post(url, {
          co_po_mapping: coPoMappingPostData,
          course_outcomes: course_outcome_ids,
        })
        .then(() => {

        })
        .catch(() => {
          error = true;
          // console.log(error.response);
        });



      let coPsoMappingPostData = [];
      await this.courseOutcomes.forEach((co) => {
        this.programSpecificOutcomes.forEach((pso) => {
          if (this.enabledPsoIds.includes(pso.id)) coPsoMappingPostData.push({
            course_outcome_id: co.id,
            programme_specificoutcome_id: pso.id,
            level: parseFloat(this.coPsoMappingData[co.id][pso.id].level).toFixed(1),
          });
        });
      });
      url = this.$store.getters.getAPIKey.copsoMapping;
      await axios
        .post(url, { co_pso_mapping: coPsoMappingPostData })
        .then(() => {
        })
        .catch(() => {
          error = true;
          // console.log(error.response);
        });

      if (error) {
        this.$toast.error("CO-PO CO-PSO Mapping failed to save.", {
          position: "top",
          duration: 5000,
        });
      } else {
        this.$toast.success("Mappings saved successfully", {
          position: "top",
          duration: 5000,
        });
        this.editTable = false;
      }
      this.saveChanges.text = "Save";
      this.saveChanges.disabled = false;
      this.loadCoPoPsoMapping();

    },

  },
};
</script>

<style >
.mappingTable table tr td,
.mappingTable table th {
  font-size: 12px;
}
.error {
  color: red;
  font-weight: bold;
}
</style>
